import { render, staticRenderFns } from "./itemAvailabilities.vue?vue&type=template&id=2b997db4&scoped=true"
import script from "./itemAvailabilities.vue?vue&type=script&lang=ts"
export * from "./itemAvailabilities.vue?vue&type=script&lang=ts"
import style0 from "./itemAvailabilities.vue?vue&type=style&index=0&id=2b997db4&prod&scoped=true&lang=css"
import style1 from "./itemDetails.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./acquisitionViews.css?vue&type=style&index=2&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b997db4",
  null
  
)

export default component.exports